import { overView } from "../client";

export const getConversationBusinesses = () => {
  return overView.get("/conversations/businesses");
};

export const getConversationThreads = (params) => {
  return overView.post("/conversations/threads", {
    businessId: params?.businessId,
    startDate: params?.startDate,
    endDate: params?.endDate,
    search: params?.search || "",
    channel: params?.channel || "",
    page: params?.page ?? 0,
    pageSize: params?.pageSize ?? 10,
  });
};

export const getConversationThread = (params) => {
  return overView.post("/conversations/thread", {
    businessId: params?.businessId,
    chatbotUserId: params?.chatbotUserId || params?.threadId,
    startDate: params?.startDate,
    endDate: params?.endDate,
  });
};
